var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-center mt-4 mb-3"},[_vm._v(_vm._s(_vm.jsonObjectContact.contactHead))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.jsonObjectContact.email))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c55778c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EN-vers/menu/Contact.vue
// module id = null
// module chunks = 